import { useEffect, useState } from "react";
import { MdCancel, MdCheck, MdClose } from "react-icons/md";
import { forgotPassword } from "../../redux/slices/authSlice";
import { useAppDispatch } from "../../redux/hooks";
import { addNotification } from "../../redux/slices/notificationSlice";
import { MessageType } from "../../types";
import {
  isValidAnnoScolastico,
  osservazionePathNum,
  osservazionePathYear,
} from "../../utils/functions";
import { useNavigate } from "react-router-dom";

interface IProps {
  idAnagrafica: number;
  show: boolean;
  onClose: () => void;
}

function FormNewOsservazionePopup(props: IProps) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [anno, setAnno] = useState(osservazionePathYear());
  const [num, setNum] = useState(osservazionePathNum());

  const handleConfirm = () => {
    if (!anno || !num) {
      dispatch(
        addNotification({
          message: "Compilare tutti i campi",
          type: MessageType.WARNING,
        })
      );
      return;
    }
    if (num < 1 || num > 2) {
      dispatch(
        addNotification({
          message: "Il periodo deve essere 1 o 2",
          type: MessageType.WARNING,
        })
      );
      return;
    }
    if (!isValidAnnoScolastico(anno)) {
      dispatch(
        addNotification({
          message: "Anno scolastico non valido (formato: YYYY-YYYY)",
          type: MessageType.WARNING,
        })
      );
      return;
    }

    navigate(`/osservazione/${props.idAnagrafica}/${anno}/${num}`);
    props.onClose();
  };

  return (
    <>
      <div
        className={`fixed inset-0 flex items-center justify-center bg-black/50 z-[900] ${
          !props.show && "hidden"
        }`}
      >
        <div className="bg-white rounded-2xl shadow-lg">
          <div className={`w-full h-14 bg-gray-300 rounded-t-2xl relative`}>
            <button className="absolute top-4 right-4 text-black">
              <MdClose size={24} onClick={props.onClose} />
            </button>
          </div>
          <div className="flex flex-col gap-4 px-6 pt-4 pb-6">
            <p className="text-lg">
              Inserisci i dati per creare la nuova osservazione
            </p>

            <div className="flex flex-col gap-3">
              <div className="form-element !grid !grid-cols-4 gap-4">
                <label htmlFor="anno">Anno</label>
                <input
                  type="text"
                  id="anno"
                  name="Anno"
                  className="col-span-3"
                  value={anno}
                  onChange={(e) => setAnno(e.target.value)}
                  placeholder={osservazionePathYear()}
                />
              </div>
              <div className="form-element !grid !grid-cols-4 gap-4">
                <label htmlFor="num">Periodo</label>
                <input
                  type="number"
                  min={1}
                  max={2}
                  id="num"
                  name="Num"
                  className="col-span-3"
                  value={num}
                  onChange={(e) => setNum(Number(e.target.value))}
                />
              </div>
            </div>

            <div className="w-full flex items-center justify-between gap-10 mt-3">
              <button onClick={props.onClose} className="btn">
                Annulla <MdCancel size={18} />
              </button>
              <button onClick={handleConfirm} className="btn btn-primary">
                Conferma <MdCheck size={18} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FormNewOsservazionePopup;
